import {
  addLeadingZeroesToZip,
  downcaseEmail,
  standardizeFullName,
  validateEndDateAbsentForMonthToMonth,
  validateNonZeroDimensionForDimensionalPricing,
  validatePricingStructureInGroup,
  validateStartDateBeforeEndDate,
} from "../hooks"
import {
  addressFields,
  contactFields,
  getBoatFields,
  getRateFields,
  toPricingStructureSelectOptions,
} from "./shared"

const toSelectOptions = (items) =>
  items.map(({ id, name }) => ({ value: id, label: name }))

export const getContractImportConfig = ({
  contractGroups,
  spaces,
  pricingStructures,
  boatTypes,
  itemizedTaxEnabled,
}) => {
  const contractGroupSelectOptions = toSelectOptions(contractGroups)
  const spaceSelectOptions = toSelectOptions(spaces)
  const pricingStructureSelectOptions =
    toPricingStructureSelectOptions(pricingStructures)

  // supercede the `boat_name`, `measurement_unit` and `length_overall`
  // shared fields with fields that include presence validations
  const baseBoatFields = getBoatFields(boatTypes)
  const boatFieldsWithOverrides = {
    ...baseBoatFields,
    boatName: {
      ...baseBoatFields.boatName,
      validators: [{ validate: "required" }],
    },
    measurementUnit: {
      ...baseBoatFields.measurementUnit,
      validators: [{ validate: "required" }],
    },
    lengthOverall: {
      ...baseBoatFields.lengthOverall,
      validators: [{ validate: "required" }],
    },
  }

  const rateFields = getRateFields(pricingStructureSelectOptions, {
    includeTax: !itemizedTaxEnabled,
  })

  const fields = [
    ...Object.values(contactFields),
    ...Object.values(addressFields),
    ...Object.values(boatFieldsWithOverrides),
    ...rateFields,
    {
      label: "Complete In House",
      key: "complete_in_house",
      type: "checkbox",
      validators: [
        {
          validate: "require_with",
          fields: ["reservation_notes"],
          errorMessage:
            "You've provided a reservation note, but this only applies when completing in house. Clear the reservation note, or check this checkbox to indicate you are completing the contract in-house.",
        },
      ],
    },
    {
      label: "Contract Group",
      key: "contract_group_id",
      type: "select",
      selectOptions: contractGroupSelectOptions,
      validators: [{ validate: "required" }],
    },
    {
      label: "Contract Notes",
      key: "contract_notes",
      type: "string",
    },
    {
      label: "Assignment",
      key: "space_id",
      type: "select",
      selectOptions: spaceSelectOptions,
    },
    {
      label: "Reservation notes",
      key: "reservation_notes",
      type: "string",
    },
    {
      label: "Start Date",
      key: "start_date",
      type: "date",
      description: "Defaults to contract group start date if blank",
    },
    {
      label: "End Date",
      key: "end_date",
      type: "date",
      description: "Defaults to contract group end date if blank",
    },
  ]

  const columnHooks = [
    { fieldName: "name", callback: standardizeFullName },
    { fieldName: "zip", callback: addLeadingZeroesToZip },
  ]

  const rowHooks = [
    downcaseEmail,
    validateEndDateAbsentForMonthToMonth(contractGroups),
    validateNonZeroDimensionForDimensionalPricing(contractGroups, "beam"),
    validateNonZeroDimensionForDimensionalPricing(
      contractGroups,
      "length_overall"
    ),
    validatePricingStructureInGroup(contractGroups),
    validateStartDateBeforeEndDate,
  ]

  return { fields, columnHooks, rowHooks }
}
